/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface IComplexOperandScope extends IOperandScope {
        getOperand(): Wars.Domain.Model.Calculations.ComplexOperand;
    }

    export class ComplexOperand implements IDirective {
        public templateUrl: string = './app/views/directives/calculate/complexOperand.html';
        public restrict: string = 'E';
        public controller = ['$scope', 'calculationService', ComplexOperandController];
        public controllerAs = 'controller';
        public scope: boolean = true; // False is use parents scope - True is create inherited scope from parents scope

        public link($scope: IComplexOperandScope, element: JQuery, attrs: ng.IAttributes, controller: ComplexOperandController) { }
    }

    export class ComplexOperandController implements IController {

        constructor(
            private $scope: IComplexOperandScope,
            private calculationService: services.CalculationService)
        {
            // Public methods using lambdas to preserve this
            this.$scope.getOperand = () => this.getOperandInternal();
        }

        private getOperandInternal(): Wars.Domain.Model.Calculations.ComplexOperand {
            return <Wars.Domain.Model.Calculations.ComplexOperand>(this.$scope.getOperation().operands[this.$scope.operandIndex]);
        }
    }
}

warsApp.registerDirective('ComplexOperand', []);